import { WelcomeShell } from '../components/composite/welcome/welcome_shell/WelcomeShell';
import type { ScreenViewProps } from '../shared/screenViewProps';
import { Button } from './button/Button';
import { Character } from './character/Character';
import { MailsDecor } from './mails_decor/MailsDecor';
import { Texts } from './texts/Texts';
import type { WelcomeDelivery2Controller } from './WelcomeDelivery2Controller';
import type { WelcomeDelivery2ScreenModel } from './WelcomeDelivery2ModelScreen';
import './welcome_delivery_2.css';

export type WelcomeDelivery2ViewProps = ScreenViewProps<
  WelcomeDelivery2ScreenModel,
  WelcomeDelivery2Controller
>;

export function WelcomeDelivery2View({
  controller,
}: WelcomeDelivery2ViewProps) {
  return (
    <WelcomeShell
      className="welcome-delivery-2"
      paginatorCurrent={2}
      afterDialog={
        <>
          <Texts />
          <MailsDecor />
          <Character />
        </>
      }
      button={<Button onClick={controller.handleContinue} />}
    />
  );
}
